// extracted by mini-css-extract-plugin
export var actionsRow = "_15-a";
export var actionsRowEnd = "_15-b";
export var askRedoBlackBtn = "_15-d";
export var askRedoBlackBtnIcon = "_15-e";
export var exitModalActionBtn = "_15-c";
export var exitModalRoot = "_15-0";
export var followUpInput = "_15-9";
export var modalContentBody = "_15-7";
export var modalHeaderImage = "_15-2";
export var modalImageLabel = "_15-4";
export var modalImageOverlay = "_15-3";
export var modalImageSubheading = "_15-6";
export var modalImageTitle = "_15-5";
export var modalImageWrapper = "_15-1";
export var reasonCard = "_15-f";
export var reasonCardSelected = "_15-g";
export var reasonIcon = "_15-j";
export var reasonIconWrap = "_15-i";
export var reasonIndicator = "_15-l";
export var reasonIndicatorDot = "_15-n";
export var reasonIndicatorSelected = "_15-m";
export var reasonLabel = "_15-h";
export var reasonList = "_15-8";
export var reasonTitle = "_15-k";